import Api from '@/services/Api'
import store from '@/store/store'

function getHeaders( ) {
	var headers = { };
	// if logged in add the sessionToken
	if ( store.state.patron.loggedIn ) {
		headers[ 'x-sirs-sessionToken' ] = store.state.patron.sessionToken;
	}
//	console.log( headers );
	return headers;
}

export default {
	login( creds ) {
		creds.login = creds.login.replace( '15/', '' );
		return Api( ).post( 'user/patron/login', {
			alternateID: creds.login,
			password: creds.password
		} );
	},
	logout( ) {
		return Api( ).post( 'user/patron/logout', { }, { headers: getHeaders( ) } );
	},
	getCircHistory( ) {
		// circHistoryRecordList
		//		bib
		//		checkOutDate
		//		title
		//		author
		//		item
		//			collection
		// includeFields=circHistoryRecordList{bib,checkOutDate,title,author,item{collection}}
		return Api( ).get( 'user/patron/key/' + store.state.patron.patronKey, {
			headers: getHeaders( ),
			params: {
				includeFields: 'circHistoryRecordList{bib,checkOutDate,title,author,item{collection}}'
			}
		} );
	},
	getBarcodeInfo( barcode ) {
		//	barcode
		//	bib
		//		title
		//		author
		//	collection
		// includeFields=barcode,bib{title,author},collection
		return Api( ).get( 'catalog/item/barcode/' + encodeURIComponent( barcode ), {
			headers: getHeaders( ),
			params: {
				includeFields: 'barcode,bib{title,author},collection'
			}
		} );
	},
	getCollectionInfo( ) {
		return Api( ).get( 'policy/collection/simpleQuery', {
			params: {
				key: '*',
				includeFields: 'pacDescription,averageReplacementCost'
			}
		} );
	}
}
